import {
  primaryColor,
  dangerColor,
  successColor,
  grayColor,
  defaultFont,
  roseColor,
  blackColor,
  infoColor
} from "../../styles";

const customInputStyle = {
  disabled: {
    "&:before": {
      backgroundColor: "transparent !important"
    }
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: blackColor[4] + " !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: roseColor[0]
    }
  },
  underlineError: {
    "&:after": {
      borderColor: dangerColor[0]
    }
  },
  underlineSuccess: {
    "&:after": {
      borderColor: roseColor[0]
    }
  },
  underlineInfo: {
    "&:after": {
      borderColor: infoColor[0]
    }
  },
  labelRoot: {
    ...defaultFont,
    color: '#888' + " !important",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    letterSpacing: "1"
  },
  labelRootError: {
    color: dangerColor[0]
  },
  labelRootSuccess: {
    color: successColor[0]
  },
  feedback: {
    position: "absolute",
    top: "18px",
    right: "0",
    zIndex: "2",
    display: "block",
    width: "24px",
    height: "24px",
    textAlign: "center",
    pointerEvents: "none"
  },
  marginTop: {
    marginTop: "16px"
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset"
  }
};

export default customInputStyle;
